// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/fullcalendar.scss
// module id = YvHf
// module chunks = 1